import React, { useRef, useLayoutEffect } from "react";
import "./Services.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Services = () => {
  const container = useRef(null);

  useLayoutEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const ctx = gsap.context(() => {
      const head = container.current.querySelector(".service__head");
      if (head) {
        gsap.fromTo(
          head,
          { opacity: 0, y: 20 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            scrollTrigger: {
              trigger: head,
              start: "top 80%",
              toggleActions: "play none none reverse",
            },
          }
        );
      }
      gsap.utils.toArray(".service").forEach((card) => {
        gsap.fromTo(
          card,
          { y: -50, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.8,
            scrollTrigger: {
              trigger: card,
              start: "top 85%",
              end: "top 30%",
              scrub: true,
            },
          }
        );
      });
    }, container);
    return () => ctx.revert();
  }, []);

  return (
    <section id="services" ref={container}>
      <div className="section__wrapper services__wrapper">
        {/* اینجا کلاس اضافه شد */}
        <div className="section__header center service__head">
          <h2 className="primary__title">Services</h2>
          <p className="text__muted description">
            I focus on building scalable and maintainable software solutions,
            collaboration with teams to ensure efficiency, quality, and
            continuous improvement across projects.
          </p>
        </div>

        <div className="services__group">
          <article className="service">
            <div className="service__top">
              <div className="icon__container" />
              <h3 className="title">Mobile Application Development</h3>
            </div>
            <div className="service__middle">
              <p className="text__muted description">
                I develop Android and cross-platform mobile applications,
                focusing on creating efficient, user-friendly, and scalable
                products. My goal is to deliver apps with smooth performance and
                intuitive interfaces that enhance the user experience.
              </p>
            </div>
          </article>

          <article
            className="service"
            style={{ "--color-primary": "var(--color-success)" }}
          >
            <div className="service__top">
              <div className="icon__container" />
              <h3 className="title">Cloud & Backend Solution</h3>
            </div>
            <div className="service__middle">
              <p className="text__muted description">
                I design and implement reliable backend systems and cloud-based
                solutions that ensure scalability, security, and performance. By
                leveraging modern cloud technologies and APIs, I build
                infrastructures that support seamless integration and future
                growth.
              </p>
            </div>
          </article>

          <article className="service">
            <div className="service__top">
              <div className="icon__container" />
              <h3 className="title">Data & Computer Vision Solutions</h3>
            </div>
            <div className="service__middle">
              <p className="text__muted description">
                I apply data analysis and computer vision techniques to transform
                raw data into actionable insights and intelligent automation.
                From uncovering patterns in datasets to building vision-based
                systems for object detection and recognition, I create solutions
                that bridge data with real-world applications.
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Services;
